export const EMAIL_STATISTICS = 'EMAIL_STATISTICS';
export const ERRORS = 'ERRORS';
